import React, { FC } from 'react';

import { EvSpinner, GraphLargeIcon as GraphIcon } from '@evinced-private/ui-common';

import { NoDataInCollection } from '../../../../components/no-data-in-collection/NoDataInCollection';
import { useDashboard } from '../../../../providers/dashboard/DashboardProvider';
import { LoadErrorMsgLayout } from '../../../property/LoadErrorMsgLayout';

interface INoDataErrorMessage {
	showOnlyPropertiesInMyCollection: boolean;
	handleClearFilters?: () => void;
}
const MAIN_TITLE = 'We don’t have enough data to activate your dashboard.';
const SECONDARY_MESSAGE = 'Please scan more properties, or contact your account admin.';

const NoDataErrorMessage: FC<INoDataErrorMessage> = ({
	showOnlyPropertiesInMyCollection,
	handleClearFilters
}) => {
	const {
		loadingDuePeriodChangeForKpis,
		loadingDuePeriodChangeForTable,
		isReadyForDataLoading,
		isActivePropertiesListLoading
	} = useDashboard();

	if (
		loadingDuePeriodChangeForKpis ||
		loadingDuePeriodChangeForTable ||
		!isReadyForDataLoading ||
		isActivePropertiesListLoading
	) {
		return <EvSpinner />;
	}

	return showOnlyPropertiesInMyCollection ? (
		<NoDataInCollection handleClearFilters={handleClearFilters} />
	) : (
		<LoadErrorMsgLayout mainTitle={MAIN_TITLE} secondaryMsg={SECONDARY_MESSAGE} icon={GraphIcon} />
	);
};

export { NoDataErrorMessage };
